<template>
    <div>
        <div class="pageHeader">{{$ml.get('PROCESS_FORM')}}</div>
        <div class="row container p-0">
            <div class="col-md-3 p-0" style="border-right:1px solid #8B929E80;">
                <div v-for="(section, index) in sectionNames" :key="index">
                    <div class="currentSection">
                        <div class="sectionBtn" :class="{active:currentSection == section.id}" @click="currentSection=section.id,scrollToSection(section.id)">{{ section.name }}</div>
                    </div>
                </div>
            </div>
            <div class="col-md-9 formSection">
                <div class="scrollable">
                    <FormRenderer id="renderable" :form-configuration="formData" v-model="formInputData" :current-step="form.current_step" :cloudApiTokens="cloudApiTokens"
                    :customerFiles="customerFiles" @submitFile="submitFile" @deleteFile="deleteFile" />

                    <!-- <div class="container-fluid pt-2" v-if="isTableAdded">
                        <table-editor :tableName="tableName" :tableData="tableData" :isBuildMode="isBuildMode" @emitJson="getTableData($event)"></table-editor>  
                    </div> -->
                    <!-- <div class="px-3 my-3" v-if="isFileAdded">
                        <h2>Dosya</h2>
                        <div class="input-group w-100 mt-2">
                            <div class="custom-file">
                                <input v-if="!btnDisabled" type="file" class="custom-file-input" id="inputGroupFile02" @change="chooseFile($event)">
                                <input v-if="btnDisabled" type="file" class="custom-file-input" id="inputGroupFile02" disabled @change="chooseFile($event)">
                                <label class="custom-file-label mb-0" for="inputGroupFile02" aria-describedby="inputGroupFileAddon02">{{ file.name || "Seçili dosya yok"}}</label>
                            </div>
                            <div class="input-group-append">
                                <button v-if="!btnDisabled" class="btn-click mcBgDark btn-new text-white px-5" type="button" id="inputGroupFileAddon04" @click="submitFile()">Yükle</button>
                                <button v-else class="btn-click mcBgDark btn-new text-white px-5" type="button" id="inputGroupFileAddon04" disabled @click="submitFile()">Yükle</button>
                            </div>
                        </div>
                        <div v-if="cloudApiTokens.length > 0">
                            <div class="col-12 w-100 mt-3 d-flex align-items-baseline">
                                <h5 class="modalTitle">Ekli Dosyalar</h5>
                                <i data-placement="bottom" class="fa fa-info-circle fileInfo text-muted mx-2" style="cursor:pointer;"></i>
                                <div class="fileInfoContext px-2 py-2" >
                                    <p><i class="fa fa-info-circle fa-2x text-muted"></i></p>
                                    <p>
                                        {{$ml.get('FILE_INFO')}}
                                    </p>
                                </div>
                            </div>
                            <div v-if="customerFiles.length>0" class="col-12 py-2 fileList w-100 m-0 fileScroll">
                                <div class="row w-100 m-0 mb-1">
                                    <div class="col-7 fileListItemTitle px-3">Dosya Adı</div>
                                    <div class="col-3 fileListItemTitle">Dosya Boyutu</div>
                                </div>
                                <div class=" row addFile w-100 m-0 mt-2" v-for="(file,index) in customerFiles" :key="index">
                                    <div class="col-7 fileListItem px-3 py-3 d-flex align-items-center">{{file.file_name}}</div>
                                    <div class="col-2 fileListItem px-3 py-3 d-flex align-items-center justify-content-center">{{setFileSize(file.file_size)}}</div>
                                    <div class="col-3 py-3 text-center text-sm-right">
                                        <router-link target="_blank" :to="{path:'/api/showCloudFile', query:{fileId: file._id.$oid}}">
                                        <button class="btn btn-light mr-1" data-toggle="tooltip" data-placement="top" title="İndiremediğiniz dosyalar için drive tarafında 3. parti çerezlere izin verilmesi gerekiyor ">
                                            <span class="fas fa-download"></span>
                                        </button>
                                        </router-link>
                                    
                                        <button class="btn btn-light text-danger" @click="deleteFile(index,file._id.$oid)"> 
                                            <span class="fas fa-trash-alt"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="px-3 py-2 fileList">
                                <div class="d-flex align-items-center flex-column pt-5">
                                    <img src="../assets/no-file-icon.png" width="50px" height="55px" class="img-fluid" alt="">
                                    <span class="pt-2 noFile">Ekli dosya yok</span>
                                </div>
                            </div>
                        </div>
                        <div v-else id="baglantiYok" class="container text-center py-5 mt-4 mb-5" style="flex-direction:column">
                            <div>
                                <img src="/static/images/google-drive-icon.png" class="img-fluid">
                                <img src="/static/images/baglanti-yok.png" class="img-fluid px-2">
                                <img src="/static/images/logo.png" class="img-fluid w-121">
                            </div>
                            <div class="d-flex flex-column align-items-center mt-4 pb-5 mb-5">
                                <h6 class="noConnectionTitle pb-1">Bağlantı Hatası</h6>
                                <span class="noConnectionDescription pb-3">Kayıtlara dosyalarınızı ekleyebilmek için google drive hesabınızla Minimum CRM'i senkronize edin.</span>
                                <router-link tag="a"  to="/settings?tab=documentManagementSettings">
                                <button class="btn-click mcBgDark btn-new text-white py-2 px-4 fileListItem text-white" >Senkronizasyonu Başlat</button>
                                </router-link>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="actionButtons mt-4">
                    <button type="button" class="btn m-1 btnLight" @click="cancel">Cancel</button>
                    <button type="button" v-if="rejectPerm" class="btn m-1 btnLight">Reject</button>
                    <button type="button" v-if="sendBackPerm" class="btn m-1 btnLight">Send back</button>
                    <button type="button" class="btn m-1 btn-primary px-4" @click="submitForm">Submit</button>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="validationErrorModal" tabindex="-1" role="dialog" aria-labelledby="validationErrorModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body d-flex align-items-center">
                        <i class="fas fa-exclamation-circle danger fa-3x" style="background: #FF0000; color: #fff; padding: 0.7rem; border-radius: 50%;"></i>
                        <p class="ml-3" style="font-size:16px; font-weight:500;" >Lütfen zorunlu alanları doldurunuz!</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" data-dismiss="modal">Kapat</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { FormRenderer } from 'v-form-builder'
import TableEditor from './tableEditorTest.vue'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
 name: "renderForm",
    components: {
        FormRenderer,
        TableEditor
    },
    data () {
        return {
            sectionNames: [],
            currentSection : "",
            formData: null,
            formInputData: null,
            rejectPerm: true,
            sendBackPerm: true,
            tableData: [ {} ],
            tableName: "",
            isTableAdded: false,
            isBuildMode: true,
            isFileAdded: false,
            btnDisabled: false,
            file: {},
            cloudApiTokens: [],
            customerFiles: [],
            customerFileIds: [],
            tokens:[
                {
                    "accountId": "58127aa2-6ae6-4dc9-b963-7ddc4dc93a43",
                    "cloudType": "google-drive"
                }
            ],
            files:[
                {
                    "storage_type": "google-drive",
                    "is_deleted": false,
                    "mime_type": "application/pdf",
                    "file_name": "BulkMMS Servisi Kullanım Kılavuzu_IYS.pdf",
                    "_id": {
                        "$oid": "63591c307763c22bf606f978"
                    },
                    "file_size": 786960,
                    "cid": {
                        "$oid": "5fdc7256e9a82a59c399c88a"
                    },
                    "cloud_api_token": {
                        "accountId": "58127aa2-6ae6-4dc9-b963-7ddc4dc93a43",
                        "fileName": "BulkMMS Servisi Kullanım Kılavuzu_IYS.pdf",
                        "fileId": "1aiRe03kTD3L23H787_eVrAN08_-JWCu9auVq-0oYvyVWFybymw"
                    }
                }
            ]
        }
    },
    props: ['form'],
    computed:{
        ...mapState([
            'baseUrl'
        ]),
    },
    created() {
        this.$root.$refs.renderForm = this
        
        this.getSections()

        if(this.form.person_id || this.form.company_id || this.form.deal_id){
            setTimeout(() => {
                this.getNames();
            }, 0);
        }
        else{
            setTimeout(() => {
                this.applyPermissions();
            }, 0);
        }
        
    },
    mounted() {
        this.getCloudApiTokens()
    },
    methods: {
        getSections() {
            let array = [], sections = this.form.form.data.sections, formControls = this.form.form.data.controls
            this.formData = this.form.form.data
            

            for(let i=1; i<=Object.keys(sections).length; i++){
                for(let key in sections){
                    if(i == sections[key]['sortOrder']){
                        if(sections[key].permission[this.form.current_step] !== 'hidden'){
                            let obj = {}
                            obj.name = sections[key]['headline']
                            obj.id = sections[key]['uniqueId']
                            array.push(obj)
                        }
                    }
                }        
            }

            var currentStep = this.form.current_step
            // var tableObj = this.form.form.tableObject
            // var fileObj = this.form.form.fileObject

            // if(tableObj.tableName !== undefined) {
            //     if(tableObj.tablePermissions[currentStep] !== undefined){
            //         if(tableObj.tablePermissions[currentStep] == 'ReadOnly' || tableObj.tablePermissions[currentStep] == 'Editable'){
            //             let obj = {}
            //             obj.name = tableObj.tableName
            //             obj.id = "form_table"
            //             array.push(obj)

            //             this.tableName = tableObj.tableName
            //             if(this.form.data['tableConfig'] !== undefined && this.form.data['tableConfig'].length > 0) {
            //                 this.tableData = this.form.data['tableConfig']
            //             }
            //             else {
            //                 this.tableData = tableObj.tableData
            //             }

            //             if(tableObj.tablePermissions[currentStep] == 'ReadOnly') {
            //                 this.isBuildMode = false
            //             }

            //             this.isTableAdded = true
            //         }
            //     }
            //     else{
            //         let obj = {}
            //         obj.name = tableObj.tableName
            //         obj.id = "form_table"
            //         array.push(obj)

            //         this.tableName = tableObj.tableName

            //         if(this.form.data['tableConfig'] !== undefined){
            //             if(this.form.data['tableConfig'].length > 0) {
            //                 this.tableData = this.form.data['tableConfig']
            //             }
            //             else {
            //                 this.tableData = tableObj.tableData
            //             }
            //         }
            //         else{
            //             this.tableData = tableObj.tableData
            //         }
                    
            //         this.isTableAdded = true
            //     }
            // }
            
            // if(fileObj.filePermissions != undefined){
            //     if(fileObj.filePermissions[currentStep] !== undefined){
                    
            //         if(fileObj.filePermissions[currentStep] == 'ReadOnly' || fileObj.filePermissions[currentStep] == 'Editable'){
                        
            //             this.customerFileIds = fileObj.customerFileIds

            //             if(fileObj.filePermissions[currentStep] == 'ReadOnly'){                            
            //                 this.btnDisabled = true
            //             }

            //             this.isFileAdded = true
            //         }
            //     }
            //     else{
            //         this.isFileAdded = true
            //     }
            //     this.customerFileIds = this.form.customerFileIds
            // }

            this.sectionNames = array
            this.customerFileIds = this.form.customerFileIds
            
            // // button permissions
            // if(this.form.form.buttonConfig[currentStep]["reject"]=== "hide"){
            //     this.rejectPerm = false
            // }
            // if(this.form.form.buttonConfig[currentStep]["sendBack"]=== "hide"){
            //     this.sendBackPerm = false
            // }           
        },
        applyPermissions() {
            let sectionContainers = document.getElementsByClassName("section-container")

            // for(let i=0;  i<sectionContainers.length; i++){
            //     sectionContainers[i].setAttribute("id", this.sectionNames[i].id) 
            // }

            // var currentStep = this.form.current_step

            // // control and section permissions
            // if(this.form.form.permissions[currentStep]){
            //     for(let perm of this.form.form.permissions[currentStep]){
            //         if(perm.component.includes("section")){
            //             for(let section of sectionContainers){
            //                 if(section.id == perm.component){
            //                     let sectionControls = section.getElementsByClassName("control-view")
            //                     if(perm.permission === "ReadOnly"){
            //                         for(let item of sectionControls){
            //                             item.firstChild.nextSibling.setAttribute("disabled", "")
            //                         }
            //                     }
            //                     else if(perm.permission === "Hidden"){
            //                         document.getElementById(perm.component).setAttribute("style", "display:none;")
            //                         for(let i=0; i<this.sectionNames.length; i++){
            //                             if(perm.component === this.sectionNames[i].id){
            //                                 this.sectionNames.splice(i, 1)
            //                             }
            //                         }
            //                     }
            //                 }
            //             }
            //         }
            //         else{
            //             if(perm.permission === "ReadOnly"){
            //                 let control = document.getElementById(perm.component)
            //                 control.setAttribute("disabled", "")
            //             }
            //             else if(perm.permission === "Hidden"){
            //                 let control = document.getElementById(perm.component).parentElement.parentElement
            //                 control.setAttribute("style", "display:none;")
            //             }
            //         }
            //     }
            // }
            
            // Fill inputs data
            // for(let control in this.form.data){
            //     if(control !== 'tableConfig') {
            //         let el = document.getElementById(control)
            //         el.value = this.form.data[control]
            //     }
            // }
            this.formInputData = this.form.data
            this.currentSection = this.sectionNames[0].id 

            var formControls = this.form.form.data.controls
            this.checkRadioList(formControls)
        },
        checkRadioList(controls) {
            let that = this

            for(var key in controls){
                if(controls[key]['type'] == "radio"){
                    this.checkSectionPermission(this.formInputData[key], key, controls)
                    
                    var buttons = document.getElementsByName(key)
                    for(let item of buttons) {
                        item.addEventListener("click", function(){
                            that.checkSectionPermission(this.value, this.name, controls)
                        })
                    }
                } 
            }
            
        },
        checkSectionPermission(value, controlId, controls) {
            if(controls[controlId]["type"] == "radio"){
                for(let item of controls[controlId]["items"]){
                    if(item.value == value){
                        this.applySectionPermisson(item, controls[controlId]["items"], value)
                        break
                    }
                }
            }
        },
        applySectionPermisson(item, controlItems, value){
            for(let item of controlItems){
                if(value == item.value){
                    if(item.show_section != undefined) {
                        this.changeDisplay(item.show_section, 'block')
                    }
                }
                else {
                    if(item.show_section != undefined) {
                        this.changeDisplay(item.show_section, 'none')
                    }
                }
            }
        },
        changeDisplay(arr, type) {
            for(let section of arr){
                let element = document.getElementById(section.uniqueId)
                element.firstChild.firstChild.setAttribute("style", "display:"+type+";")

                let controls = element.getElementsByClassName('control-view')
                for(let el of controls) {
                    el.firstChild.setAttribute("style", "display:"+type+";")
                }
                if(type=='none'){
                    this.doesSectionContainsRadio(section)
                }
                this.updateSectionNames()
            }
        },
        doesSectionContainsRadio(section) {
            var formControls = this.form.form.data.controls
            for(let key of section.controls) {
                if(formControls[key].type == 'radio') {
                    for(let item of formControls[key]['items']){
                        if(item.show_section){
                            this.changeDisplay(item.show_section, 'none')
                        }
                    }
                }
            }
        },
        getStyle(id, name){
            var element = document.getElementById(id).firstChild.firstChild;
            return element.currentStyle ? element.currentStyle[name] : window.getComputedStyle ? window.getComputedStyle(element, null).getPropertyValue(name) : null;
        },
        updateSectionNames(){
            var formSections = this.form.form.data.sections
            var arr = []
            for(let i=1; i<=Object.keys(formSections).length; i++){
                for(let key in formSections){
                    if(i == formSections[key]['sortOrder']){
                        let displayMode = this.getStyle(key, 'display');
                        
                        if(displayMode == "block"){
                            let obj = {}
                            obj.name = formSections[key]['headline']
                            obj.id = formSections[key]['uniqueId']
                            arr.push(obj)
                        }
                    }
                }        
            }
            this.sectionNames = arr
        },
        cancel() {
            this.$emit("cancel")
        },
        scrollToSection(id) {
            const element = document.getElementById(id);
            element.scrollIntoView();
        },
        submitForm() {
            if(this.isTableAdded){
                this.$root.$refs.tableEditor.emitJson()
            }         

            let obj = {}
            obj.data = this.formInputData
            obj.process_id = this.form._id.$oid
            obj.form_id = this.form.form_id
            obj.name = this.form.name
            obj.customerFileIds = this.customerFileIds

            var dataKeys = Object.keys(obj.data)

            dataKeys.forEach(key => {
                if(Array.isArray(obj.data[key])){
                    if(key.includes("section")){
                        for(let item of obj.data[key]){
                            const tempId = item.$id
                            delete item.$id
                            item.id = tempId
                        }
                    }
                }
            });
            
            var controlInputs = this.checkProcessInputs()
            if(controlInputs.person_id != null && controlInputs.person_id != ""){
                obj.person_id = controlInputs.person_id
            }

            if(controlInputs.company_id != null && controlInputs.company_id != ""){
                obj.company_id = controlInputs.company_id
            }

            if(controlInputs.deal_id != null && controlInputs.deal_id != ""){
                obj.deal_id = controlInputs.deal_id
            }

            for(let i = 0; i<this.form.form.flow.sequence.length; i++){
                let step = this.form.form.flow.sequence
                if(step[i] === this.form.current_step){
                    if(this.form.current_step !== 'completed'){
                        obj.current_step = step[i+1]
                    }
                    else{
                        obj.current_step = this.form.current_step
                    }
                }
                
            }
            console.log(obj);
            if(this.checkValidations()){
                this.$emit("update", obj)
            }
        },
        checkProcessInputs(){
            var person_input = document.getElementsByClassName("person-input")[0]
            var organization_input = document.getElementsByClassName("organization-input")[0]
            var deal_input = document.getElementsByClassName("deal-input")[0]

            var person_id = null, company_id = null, deal_id = null

            
            if(person_input != undefined){
                person_id = this.formInputData[person_input.getElementsByTagName("input")[0].id ]
            }

            if(organization_input != undefined){
                company_id = this.formInputData[organization_input.getElementsByTagName("input")[0].id]
            }

            if(deal_input != undefined){
                deal_id = this.formInputData[deal_input.getElementsByTagName("input")[0].id]
            }

            var obj = {
                person_id: person_id,
                company_id: company_id,
                deal_id: deal_id
            }
            
            return obj
        },
        checkValidations(){
            var check = true
            var controls = this.form.form.data.controls
            for(let key in controls){
                if(controls[key].validations.length > 0){
                    for(let vld of controls[key].validations){
                        if(vld.ruleType === "required"){
                            var controlInput = document.getElementById(key)
                            if(this.formInputData[key] == "" || this.formInputData[key] == undefined){
                                $('#validationErrorModal').modal('show')
                                controlInput.style.border = '1px solid red';
                                check = false
                            }
                            else{
                                if(controlInput.tagName == "DIV"){
                                    controlInput.style.border = 'none';
                                }
                                else{
                                    controlInput.style.border = '1px solid #ced4da';
                                }                                
                            }
                        }
                    }
                }
            }
            return check
        },
        submitFile(file){
            let that = this
            if(file.name){
                let formData = new FormData();
                formData.append('myFile', file);
                axios.post(
                    this.baseUrl + '/uploadFile',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(function(response){
                    if(response.data.status.desc=="Sunucuda bir hata meydana geldi! Senkronizasyon Drive Tarafinda Kapali"){
                        Swal.fire({
                            title: "Uyarı",
                            text: "Sunucuda bir hata meydana geldi! Senkronizasyon Drive Tarafinda Kapali",
                            icon: "error",
                            confirmButtonColor: '#d33',
                            confirmButtonText:"Tamam",
                            customClass:{
                                icon:'custom-error-error',
                            },
                            reverseButtons:true
                        })
                    }

                    that.customerFileIds.push(response.data.content.oid)
                    that.getCustomerFiles()
                })
            }
            else{
                console.log("dosya seçiniz");
            }
        },
        getCloudApiTokens() {
            axios({
                method: 'GET',
                url: '/getAllDefaultCloudApiTokens',
                baseURL: this.baseUrl,
             }).then(response => {
              
            if(response.data.content){ 
                this.cloudApiTokens = response.data.content.tokens ;
                this.getCustomerFiles()
            }
            }).catch(error => {
            this.$notify({ 
                group: 'foo',
                type: 'error', 
                title: this.$ml.get('ERROR'),
                text: error
            })
            });
        },
        getCustomerFiles() {
            if(this.customerFileIds.length>0){
                axios({
                    method: 'GET',
                    url: '/listCustomerFiles',
                    baseURL: this.baseUrl,
                    params:{
                        customerFileIds:'['+this.customerFileIds.join(',')+']'
                    }
                }).then(response => {
                    this.customerFiles = response.data.content.files.reverse()
                }).catch(error => {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: error
                    })
                });
            }
            else{
                this.customerFiles = []
            }
        },
        deleteFile(fileId){
            var confirm_message = this.$ml.get('DELETE_FILE_CONFIRM')
            Swal.fire({
                title: this.$ml.get('DELETE_FILE'),
                text: confirm_message,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: this.$ml.get('DELETE_FILE_CONFIRM_BTN_TXT'),
                cancelButtonText: this.$ml.get('CANCEL'),
                customClass:{
                    icon:'custom-delete-warning',
                    cancelButton:'custom-delete-cancel-button'
                },
                reverseButtons:true
                }).then((response)=>{
                    axios({
                    method: 'POST',
                    url: '/deleteCustomerFile',
                    baseURL: this.baseUrl,
                    data: {
                        fileId: fileId
                    },
                    }).then(response => {                        
                        var item = this.customerFileIds.indexOf(fileId);
                        this.customerFileIds.splice(item, 1);
                        this.getCustomerFiles()                         

                    }).catch(error => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: this.$ml.get('ERROR'),
                            text: error
                        })
                    });
                }
        )},
        quickSearch(id, url, key, control_id){
            var fullName = null

            axios({
                method:'POST',
                url:url,
                baseURL: this.baseUrl,
                data: {
                    [key]:id,
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    if(key == 'contactId'){
                        if(res.data.content.contact.sn){
                            fullName = res.data.content.contact.n + res.data.content.contact.sn
                        }
                        else{
                            fullName = res.data.content.contact.n
                        }
                    }
                    if(key == "organizationId"){
                        fullName = res.data.content.organization.name
                    }
                    if(key == "dealId"){
                        fullName = res.data.content.deal.title
                    }
                    document.getElementById(control_id).value = fullName
                }else{
         
                }
            })
            setTimeout(() => {
                this.applyPermissions();
            }, 0);
        },
        getNames(){
            if(this.form.person_id){
                var element = document.getElementsByClassName("person-input")

                if(typeof(element) != 'undefined' && element != null && element.length > 0){
                    let control_id =  document.getElementsByClassName("person-input")[0].getElementsByTagName('input')[0].id
                    this.quickSearch(this.form.person_id.$oid, "getContact", "contactId", control_id)
                }
            }
            if(this.form.company_id){
                var element = document.getElementsByClassName("organization-input")

                if(typeof(element) != 'undefined' && element != null && element.length > 0){
                    let control_id =  element[0].getElementsByTagName('input')[0].id
                    this.quickSearch(this.form.company_id.$oid, "getOrganization", "organizationId", control_id)
                }
            }
            if(this.form.deal_id){
                var element = document.getElementsByClassName("deal-input");
                
                if(typeof(element) != 'undefined' && element != null && element.length > 0){
                    let control_id =  element[0].getElementsByTagName('input')[0].id
                    this.quickSearch(this.form.deal_id.$oid, "getDeal", "dealId", control_id)
                }
            }
        },
        getTableData(data) {
            this.formInputData["tableConfig"] = data
        },
        chooseFile(event){
            this.file = event.target.files[0]
        },
        setFileSize(bytes){
            if      (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
            else if (bytes >= 1048576)    { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
            else if (bytes >= 1024)       { bytes = (bytes / 1024).toFixed(2) + " KB"; }
            else if (bytes > 1)           { bytes = bytes + " bytes"; }
            else if (bytes == 1)          { bytes = bytes + " byte"; }
            else                          { bytes = "0 bytes"; }
            return bytes;
        }
    },
}
</script>

<style scoped>
    .pageHeader {
        display: flex;
        align-items: center;
        background-color: #FFFFFF;
        position: absolute;
        width: 100%;
        top: 6%;
        left: 0;
        margin: 0 auto;
        height: 70px;
        z-index: 99;
        color: #333333CC;
        font-size: 24px;
        font-weight: 700;
        padding-left: 10%;
    }
    .container {
        display: flex;
        background: #FFFFFF;
        min-height: 84vh;
        border-radius: 4px;
        margin-top: 8%;
    }
    .currentSection .active {
        background: #009FF71A;
        border-right: 4px solid #009FF7;
    }
    .sectionBtn {
        padding: 15px;
        color: #009FF7;
        font-weight: 500;
        font-size: 1rem;
        cursor: pointer;
    }
    .formSection {
        padding: 30px 15px 15px 15px;
    }
    .btn {
        min-width: 120px;
    }
    .actionButtons {
        display: flex;
        align-items: center;
        justify-content: end;
    }
    .btnLight {
        background: #E9EDF5;
        color: #333333CC;
        font-weight: 500;
    }
    .btnLight:hover {
       background: #d8d8d8; 
    }
    .custom-file-label{
        padding-left:80px;
        color: #D1D1D7;
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        overflow: hidden;
    }
    .custom-file-label::after{
        left: 0;
        right: auto;
        content: "Göz At";
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        background-color: #3767a0 !important;
        cursor: pointer !important;
        color: #fff !important;
    }
    .addFile{
        background-color: #FAFAFA;
        border: 1px solid #E7E7E8;
        box-sizing: border-box;
        border-radius: 4px;
    }
    .fileInfo:hover + .fileInfoContext{
        display:block;
        position: absolute;
    }
    .fileInfoContext{
        display: none;
        width: 190px;
        height: 150px;
        border: 1px solid gray;
        border-radius: 4px;
        position: relative;
        top: 33px;
        z-index: 99999;
        background:#FAFAFA;
    }
    .fileList{
        height: 250px;
        background-color: #FAFAFA;
        border: 1px solid #E7E7E8;
        box-sizing: border-box;
        border-radius: 4px;
    }
    .noConnectionTitle{
        font-weight: bold;
        font-size: 16px;
        line-height: 21px;
        color: #2E323C;
    }
    .noConnectionDescription{
        font-size: 16px;
        line-height: 20px;
        color: #7e8187;
        max-width: 445px;
    }
    .fileListItem{
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        color: #7e8187;
    }
    .fileListItemTitle{
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
        color: #2E323C;
    }

    .scrollable {
        box-sizing: border-box;
        height: 72vh;
        overflow-y: scroll;
    }
    /* Hide scrollbar for Chrome, Safari and Opera */
    .scrollable::-webkit-scrollbar {
        display: none;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    .scrollable {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
    .fileScroll::-webkit-scrollbar {
        display: none;
    }
    .fileScroll {
    -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
    .fileScroll {
        overflow-y: scroll; /* Add the ability to scroll */
    }
</style>
